<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Parametry produktów</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Parametry produktów</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Parametry produktów</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddParameter" to="/parameters/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  @expand-row="editParameters"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis parametru [pl]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isPlOpen = !isPlOpen"
                            >
                              <i :class="chevronPlClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isPlOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="parameterObj.name_pl"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_pl"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_pl[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis parametru [en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isEnOpen = !isEnOpen"
                            >
                              <i :class="chevronEnClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isEnOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="parameterObj.name_en"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_en"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_en[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis parametru [de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeOpen = !isDeOpen"
                            >
                              <i :class="chevronDeClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isDeOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="parameterObj.name_de"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_de"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_de[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis parametru [de_de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeDeOpen = !isDeDeOpen"
                            >
                              <i :class="chevronDeDeClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isDeDeOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="parameterObj.name_cpde"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_cpde"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_cpde[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis parametru [de_en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeEnOpen = !isDeEnOpen"
                            >
                              <i :class="chevronDeEnClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isDeEnOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="parameterObj.name_cpen"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_cpen"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_cpen[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="canViewParameterOption"
                          class="ibox float-e-margins"
                        >
                          <div class="ibox-title">
                            <h5>Parametry</h5>
                            <span
                              class="ibox-toggle"
                              @click="isParamOptionsOpen = !isParamOptionsOpen"
                            >
                              <i :class="chevronParamOptionsClass"></i>
                            </span>
                          </div>
                          <div
                            class="form-horizontal"
                            v-show="isParamOptionsOpen"
                          >
                            <div class="ibox-content">
                              <div
                                class="table-responsive"
                                v-if="parameterObj.options?.length"
                              >
                                <table
                                  class="table table-bordered table-striped"
                                >
                                  <thead>
                                    <tr>
                                      <th class="drag-col">#</th>
                                      <th>Nazwa PL</th>
                                      <th>Nazwa EN</th>
                                      <th>Nazwa DE</th>
                                      <th>Nazwa EN (DE)</th>
                                      <th>Nazwa DE (DE)</th>
                                      <th class="actions-col">Akcje</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(
                                        option, index
                                      ) in parameterObj.options"
                                      :key="option.pk ?? `new-option-${index}`"
                                      :draggable="
                                        canChangeParameterOption &&
                                        editingOptionIndex === null
                                      "
                                      @dragstart="
                                        onOptionDragStart(index, $event)
                                      "
                                      @dragover="
                                        onOptionDragOver(index, $event)
                                      "
                                      @drop="onOptionDrop(index, $event)"
                                      @dragend="onOptionDragEnd"
                                      :class="{
                                        'drag-over-row':
                                          dragOverOptionIndex === index,
                                      }"
                                    >
                                      <td
                                        class="drag-handle"
                                        title="Przeciągnij, aby zmienić kolejność"
                                      >
                                        <i class="fa fa-bars"></i>
                                      </td>
                                      <td>
                                        <input
                                          v-model="option.name_pl"
                                          type="text"
                                          class="form-control inputClass"
                                          placeholder="Nazwa PL"
                                          :disabled="!isOptionEditing(index)"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          v-model="option.name_en"
                                          type="text"
                                          class="form-control inputClass"
                                          placeholder="Nazwa EN"
                                          :disabled="!isOptionEditing(index)"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          v-model="option.name_de"
                                          type="text"
                                          class="form-control inputClass"
                                          placeholder="Nazwa DE"
                                          :disabled="!isOptionEditing(index)"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          v-model="option.name_cpen"
                                          type="text"
                                          class="form-control inputClass"
                                          placeholder="Nazwa EN (DE)"
                                          :disabled="!isOptionEditing(index)"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          v-model="option.name_cpde"
                                          type="text"
                                          class="form-control inputClass"
                                          placeholder="Nazwa DE (DE)"
                                          :disabled="!isOptionEditing(index)"
                                        />
                                      </td>
                                      <td class="actions-col">
                                        <button
                                          v-if="
                                            canChangeParameterOption &&
                                            !isOptionEditing(index)
                                          "
                                          class="btn btn-warning btn-xs"
                                          @click.stop="
                                            startEditParameterOption(index)
                                          "
                                        >
                                          <i class="fa fa-pencil"></i>
                                        </button>
                                        <button
                                          v-else-if="isOptionEditing(index)"
                                          class="btn btn-success btn-xs"
                                          @click.stop="stopEditParameterOption"
                                        >
                                          <i class="fa fa-check"></i>
                                        </button>
                                        <button
                                          v-if="canDeleteParameterOption"
                                          class="btn btn-danger btn-xs m-l-xs"
                                          @click.stop="
                                            removeParameterOption(index)
                                          "
                                        >
                                          <i class="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div v-else class="text-muted m-b-sm">
                                Brak opcji parametru.
                              </div>
                              <button
                                v-if="canAddParameterOption"
                                class="btn btn-primary btn-sm"
                                @click.stop="addParameterOption"
                              >
                                Dodaj opcję
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Konfiguracja parametru produktu</h5>
                            <span
                              class="ibox-toggle"
                              @click="isConfigOpen = !isConfigOpen"
                            >
                              <i :class="chevronConfigClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal" v-show="isConfigOpen">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Nazwa zmiennej
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="parameterObj.var_name"
                                    name="name"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa zmiennej"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.var_name"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.var_name[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="col-sm-4 col-sm-offset-2">
                                  <button class="btn btn-white" @click="cancel">
                                    Anuluj
                                  </button>
                                  <button
                                    v-if="canChangeParameter"
                                    @click="saveEdit"
                                    class="btn btn-primary"
                                  >
                                    Zapisz
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteParameter"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.name;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                  <template #item-image="item">
                    <img :src="item.image" />
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteParameters(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import {
  productParameterOptionPermissionsConst,
  productParameterPermissionsConst,
} from "../../constants/productConstants";
import Modal from "../caffeprint/Modal.vue";

export default {
  name: "ParametersList",
  mixins: [],
  components: {
    Modal,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddParameter = computed(() =>
      hasPermission(productParameterPermissionsConst.add)
    );
    const canChangeParameter = computed(() =>
      hasPermission(productParameterPermissionsConst.update)
    );
    const canDeleteParameter = computed(() =>
      hasPermission(productParameterPermissionsConst.delete)
    );
    // Parameter options are a separate model with their own permissions - the
    // old panel gates the nested options table with them.
    const canViewParameterOption = computed(() =>
      hasPermission(productParameterOptionPermissionsConst.view)
    );
    const canAddParameterOption = computed(() =>
      hasPermission(productParameterOptionPermissionsConst.add)
    );
    const canChangeParameterOption = computed(() =>
      hasPermission(productParameterOptionPermissionsConst.update)
    );
    const canDeleteParameterOption = computed(() =>
      hasPermission(productParameterOptionPermissionsConst.delete)
    );
    const errorsAdminData = ref();
    const deleteParametersData = computed(
      () => store.getters.getDeleteParametersData
    );
    const parameterData = computed(() => store.getters.getParameterData);
    const updateParametersData = computed(
      () => store.getters.getUpdateParametersData
    );
    const parametersData = computed(() => store.getters.getParametersData);
    const parameterObj = ref({
      name: "",
      model: "",
      type: "",
      image: "",
    });
    let headers = [
      { text: "ID", value: "pk" },
      {
        text: "Nazwa",
        value: "name",
        sortable: true,
        search: true,
      },
      {
        text: "Nazwa zmiennej",
        value: "var_name",
        sortable: true,
        search: true,
      },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const isMainOpen = ref(true);
    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isDeFrOpen = ref(true);
    const isParamOptionsOpen = ref(true);
    const isConfigOpen = ref(true);
    const editingOptionIndex = ref(null);
    const draggedOptionIndex = ref(null);
    const dragOverOptionIndex = ref(null);

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEnClass = computed(() =>
      isEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeClass = computed(() =>
      isDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeDeClass = computed(() =>
      isDeDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeEnClass = computed(() =>
      isDeEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeFrClass = computed(() =>
      isDeFrOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronParamOptionsClass = computed(() =>
      isParamOptionsOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronConfigClass = computed(() =>
      isConfigOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const setOptionPositions = () => {
      if (!Array.isArray(parameterObj.value.options)) {
        parameterObj.value.options = [];
      }

      parameterObj.value.options = parameterObj.value.options.map(
        (option, index) => ({
          ...option,
          position: index + 1,
        })
      );
    };

    const addParameterOption = () => {
      if (!canAddParameterOption.value) {
        return;
      }
      if (!Array.isArray(parameterObj.value.options)) {
        parameterObj.value.options = [];
      }

      parameterObj.value.options.push({
        name_pl: "",
        name_en: "",
        name_de: "",
        name_cpen: "",
        name_cpde: "",
      });
      setOptionPositions();
      editingOptionIndex.value = parameterObj.value.options.length - 1;
    };

    const removeParameterOption = (index) => {
      if (!canDeleteParameterOption.value) {
        return;
      }
      parameterObj.value.options.splice(index, 1);
      if (editingOptionIndex.value === index) {
        editingOptionIndex.value = null;
      } else if (editingOptionIndex.value > index) {
        editingOptionIndex.value -= 1;
      }
      setOptionPositions();
    };

    const isOptionEditing = (index) => editingOptionIndex.value === index;

    const startEditParameterOption = (index) => {
      if (!canChangeParameterOption.value) {
        return;
      }
      editingOptionIndex.value = index;
    };

    const stopEditParameterOption = () => {
      editingOptionIndex.value = null;
    };

    const onOptionDragStart = (index, event) => {
      if (editingOptionIndex.value !== null) {
        event.preventDefault();
        return;
      }
      draggedOptionIndex.value = index;
      if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
      }
    };

    const onOptionDragOver = (index, event) => {
      if (editingOptionIndex.value !== null) {
        return;
      }
      event.preventDefault();
      dragOverOptionIndex.value = index;
    };

    const onOptionDragEnd = () => {
      draggedOptionIndex.value = null;
      dragOverOptionIndex.value = null;
    };

    const onOptionDrop = (index, event) => {
      if (
        !canChangeParameterOption.value ||
        editingOptionIndex.value !== null
      ) {
        return;
      }

      event.preventDefault();

      if (
        draggedOptionIndex.value === null ||
        draggedOptionIndex.value === index
      ) {
        onOptionDragEnd();
        return;
      }

      const [movedOption] = parameterObj.value.options.splice(
        draggedOptionIndex.value,
        1
      );
      parameterObj.value.options.splice(index, 0, movedOption);
      setOptionPositions();
      onOptionDragEnd();
    };

    const getParameters = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getParameters", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deleteParameters = (pk) => {
      showModal.value = false;
      if (!canDeleteParameter.value) {
        return;
      }
      store.dispatch("deleteParameters", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeParameter.value) {
        return;
      }
      setOptionPositions();
      store.dispatch("updateParameters", parameterObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editParameters = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getParameter", { pk: items.value[localIndex].pk });
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getParameters();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      selectPage(1);
      getParameters();
    };

    const updateSort = () => {
      search.value = true;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("paramsSearchValue") !== null) {
        searchValue.value = localStorage.getItem("paramsSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }

      getParameters();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "paramsSearchValue",
          JSON.stringify(searchValue.value)
        );
        getParameters();
      },
      { deep: true }
    );

    watch(
      () => parametersData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => parameterData.value,
      function (newValue) {
        parameterObj.value = newValue.data;
        if (!Array.isArray(parameterObj.value?.options)) {
          parameterObj.value.options = [];
        }
        editingOptionIndex.value = null;
        onOptionDragEnd();
        setOptionPositions();
      }
    );

    watch(
      () => deleteParametersData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Parametr został usunięty",
          });
        }
        getParameters();
      }
    );

    watch(
      () => updateParametersData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getParameters();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }
        errorsAdminData.value = newValue;

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getParameters();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      canAddParameter,
      canChangeParameter,
      canDeleteParameter,
      canViewParameterOption,
      canAddParameterOption,
      canChangeParameterOption,
      canDeleteParameterOption,
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deleteParameters,
      deleteName,
      errorsAdminData,
      parameterObj,
      cancel,
      editParameters,
      saveEdit,
      addParameterOption,
      removeParameterOption,
      isOptionEditing,
      startEditParameterOption,
      stopEditParameterOption,
      onOptionDragStart,
      onOptionDragOver,
      onOptionDrop,
      onOptionDragEnd,
      editingOptionIndex,
      dragOverOptionIndex,
      searchValue,
      isSearch,
      rowsPerPage,
      resetFilters,
      updateSort,
      search,
      setRowsPerPage,
      selectPage,
      isMainOpen,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isDeFrOpen,
      isParamOptionsOpen,
      isConfigOpen,
      chevronMainClass,
      chevronPlClass,
      chevronEnClass,
      chevronDeClass,
      chevronDeDeClass,
      chevronDeEnClass,
      chevronDeFrClass,
      chevronParamOptionsClass,
      chevronConfigClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}

.actions-col {
  width: 95px;
  white-space: nowrap;
}

.drag-col {
  width: 40px;
}

.drag-handle {
  text-align: center;
  cursor: move;
  color: #676a6c;
}

.drag-over-row {
  background-color: #f3f3f4;
}

input:disabled {
  background-color: #f5f5f5;
}
</style>
